module.exports = __webpack_public_path__ + "media/images/front/columns_test_img_03-38e55333d0844b19d93dd98db9d6e512.png";